{
  "api": {
    "navigation_title": "API Keys",
    "create_token": "Create API Key",
    "docs": "Docs",
    "title": "API Keys",
    "filter_input": "Filter API keys...",
    "remove_token": "Remove API Key",
    "select_org": "Select Organization",
    "never_used": "Never Used",
    "dialogs": {
      "delete": {
        "title": "Are you sure?",
        "content": "Are you sure you want to delete this API key? You can't undo this action"
      }
    },
    "token": "Key",
    "organization": "Organization",
    "created": "Created by",
    "device": "Device Scope",
    "permissions": "Permissions",
    "requests_number": "Requests",
    "last_used_at": "Last Used"
  }
}
